import USBAccordion from "@usb-shield/react-accordion";
//import { useState } from "react";
import headsetIcon from "../assets/headset.svg";

const USER_GUIDE = [
  {
    category: "User Manual",
    items: [
      {
        id: "pdf-1",
        headingText: "Elavon Data Platform User Guide",
        isExpanded: false,
      },
      {
        id: "pdf-2",
        headingText: "Authorization Rate Improvement Data Service",
        isExpanded: false,
      },
      {
        id: "pdf-3",
        headingText: "Disputes Optimization Data Service",
        isExpanded: false,
      },
      {
        id: "pdf-4",
        headingText: "Interchange & Downgrade Insights Data Service",
        isExpanded: false,
      },
    ],
  },
  {
    category: "Demo Videos",
    items: [
      {
        id: "video-1",
        headingText: "Authorization Dashboard",
        isExpanded: false,
      },
      {
        id: "video-2",
        headingText: "Disputes Dashboard",
        isExpanded: false,
      },
      {
        id: "video-3",
        headingText: "Interchange & Downgrade Dashboard",
        isExpanded: false,
      },
    ],
  },
];

const HelpCenter = () => {
  //  const [selectedItem, setSelectedItem] = useState(null);
  //   const [accordions, setAccordions] = useState(USER_GUIDE["User Manual"]);

  return (
    <div className="help-center">
      <div className="help-center__sidebar">
        {USER_GUIDE.map((section) => (
          <div key={section.category}>
            <h3 className="help-center-h3">{section.category}</h3>
            <USBAccordion
              id={`accordion-${section.category}`}
              accordions={section.items}
            />
          </div>
        ))}
      </div>

      <div className="help-center__content">
        <div className="help-center__placeholder">
          <img
            src={headsetIcon}
            alt=""
            aria-hidden="true"
            width="64"
            height="64"
            className="help-center__placeholder-icon"
          />
          <h2>Help Center coming soon</h2>
          <p>
            User guides and demo videos for every dashboard will be available
            here soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
